/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventClipDto } from '../../models/event-clip-dto';

export interface VisionEventsControllerGetEventClip$Params {
  uuid: string;
  eventUuid: string;
}

export function visionEventsControllerGetEventClip(http: HttpClient, rootUrl: string, params: VisionEventsControllerGetEventClip$Params, context?: HttpContext): Observable<StrictHttpResponse<EventClipDto>> {
  const rb = new RequestBuilder(rootUrl, visionEventsControllerGetEventClip.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('eventUuid', params.eventUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EventClipDto>;
    })
  );
}

visionEventsControllerGetEventClip.PATH = '/match-videos/{uuid}/events/{eventUuid}/clip';
